import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLookupOptions } from '@frontend/pricing-search';
import ScenarioFooter from '../components/ScenarioFooter';
import ChannelSelectCard from '../components/ChannelSelectCard';
import { ScenarioPageContent, SectionLabel } from '../components/styled';
import { useChannelTypes } from '../hooks/useChannelTypes';
import { useScenarioContext } from '../hooks/useScenarioContext';
import { PATH_SCENARIO_SEARCH } from '../../../route/constants';
import Common from '../../../common/services/Common';
import { getZeroBasedPricingSelector } from '../../../data/lockSummary/actionCreators';
import { AppDispatch } from '../../../store';

export const ScenarioChannelSelect: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { selectedChannel, setSelectedChannel, setIsSingleChannel } = useScenarioContext();
  const documentationTypes = useLookupOptions('documentationTypes') || [];
  const lookupsReady = documentationTypes.length > 0;
  const { channels, isLoading } = useChannelTypes(
    selectedChannel,
    setSelectedChannel,
    dispatch,
    setIsSingleChannel,
    lookupsReady,
  );

  const handleCancel = () => {
    Common.closeApplication();
  };

  const handleNext = async () => {
    if (selectedChannel) {
      await dispatch(getZeroBasedPricingSelector(selectedChannel.id) as any);
      navigate(PATH_SCENARIO_SEARCH);
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <>
      <ScenarioPageContent>
        <SectionLabel>Scenarios</SectionLabel>
        <ChannelSelectCard
          channels={channels}
          selectedChannel={selectedChannel}
          onChannelSelect={setSelectedChannel}
        />
      </ScenarioPageContent>
      <ScenarioFooter
        onCancel={handleCancel}
        onNext={handleNext}
        isNextDisabled={!selectedChannel}
      />
    </>
  );
};

export default ScenarioChannelSelect;
